/* MXDVS newsletter page (/pages/newsletter), live Dawn theme, 07.10.2026.
   Sends the sign-up without a page reload, the same way as the V2 footer/pop-up:
   1. the visitor's submit is checked (valid address) and shows "Sending...";
   2. the form is submitted again through the browser so Shopify's spam
      protection (hCaptcha) can add its token;
   3. that submit is sent with fetch. Shopify's answer tells us:
      ok      -> "Check your mailbox"
      exists  -> "You are already subscribed" (Shopify says the address is taken)
      other   -> error message.
   The address is also sent to Klaviyo's Email List (list XdHuwg, client request,
   public key only) so the 10% welcome email starts right away. Signup source:
   "MXDVS newsletter page", profile property MXDVS Signup Source = "newsletter-page".
   Addresses that signed up in this browser (here, footer or pop-up) are remembered
   and get "You are already subscribed" straight away.
   If Shopify wants a visible spam check, the visitor goes to that page and the
   result shows when they come back. */
(function () {
  'use strict';

  var LIST_KEY = 'mxnl_emails';
  var DONE_KEY = 'mxnl_subscribed';
  var PENDING_KEY = 'mxnp_pending';
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var sleep = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function ssDel(k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  function knownEmails() { try { return JSON.parse(lsGet(LIST_KEY)) || []; } catch (e) { return []; } }
  function rememberEmail(em) {
    if (!em) return;
    var l = knownEmails();
    if (l.indexOf(em) < 0) { l.push(em); lsSet(LIST_KEY, JSON.stringify(l.slice(-20))); }
    lsSet(DONE_KEY, em);
  }

  /* ---------- Klaviyo: subscribe to the Email List ---------- */
  var KL_BASE = 'https://a.klaviyo.com/client/';
  var KL_KEY = 'UKxycP';
  var KL_REVISION = '2026-07-15';
  var KL_LIST = 'XdHuwg';
  var KL_SOURCE_PROP = 'MXDVS Signup Source';
  var KL_SOURCE = 'MXDVS newsletter page';
  var KL_SOURCE_KEY = 'newsletter-page';
  function klPost(path, payload) {
    var body = JSON.stringify(payload);
    function go(keep) {
      return fetch(KL_BASE + path + '/?company_id=' + KL_KEY, {
        method: 'POST', keepalive: keep,
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': KL_REVISION },
        body: body
      });
    }
    try { return go(true).catch(function () { return go(false); }).catch(function () {}); }
    catch (e) { return Promise.resolve(); }
  }
  function klaviyoSubscribe(email) {
    var props = {}; props[KL_SOURCE_PROP] = KL_SOURCE_KEY;
    return Promise.all([
      klPost('subscriptions', { data: {
        type: 'subscription',
        attributes: {
          custom_source: KL_SOURCE,
          profile: { data: { type: 'profile', attributes: {
            email: email,
            subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
          } } }
        },
        relationships: { list: { data: { type: 'list', id: KL_LIST } } }
      } }),
      klPost('profiles', { data: { type: 'profile', attributes: { email: email, properties: props } } })
    ]);
  }

  function init(root) {
    if (!root || root._mxnp) return;
    root._mxnp = true;

    var T = {};
    try { T = JSON.parse(root.querySelector('[data-mxnp-copy]').textContent); } catch (e) {}
    var form = root.querySelector('form');
    var input = root.querySelector('[data-mxnp-email]');
    var msg = root.querySelector('[data-mxnp-msg]');
    var done = root.querySelector('[data-mxnp-done]');
    var doneText = root.querySelector('[data-mxnp-done-text]');
    var doneNote = root.querySelector('[data-mxnp-done-note]');
    var flagEl = root.querySelector('[data-mxnp-result]');
    var flag = flagEl ? flagEl.getAttribute('data-mxnp-result') : '';
    if (!form || !input) return;

    function say(text, err) {
      msg.textContent = text || '';
      msg.classList.toggle('is-err', !!err);
      msg.hidden = !text;
    }
    function showResult(kind) {
      var text = kind === 'ok' ? T.ok : kind === 'exists' ? T.exists : T.error;
      var note = kind === 'ok' ? T.okNote : kind === 'exists' ? T.existsNote : '';
      root.classList.remove('is-busy');
      if (kind === 'error') {
        /* keep the form so they can try again */
        say(text, true);
        busy = false; sent = false; validated = '';
        return;
      }
      form.hidden = true;
      doneText.textContent = text || '';
      doneNote.textContent = note || '';
      done.classList.remove('is-err');
      done.hidden = false;
    }
    function finish(kind, email) {
      if (kind === 'ok' || kind === 'exists') rememberEmail(email);
      showResult(kind);
    }

    input.addEventListener('input', function () { if (msg.classList.contains('is-err')) say('', false); });

    var busy = false, releasing = false, validated = '', sent = false, inflight = 0, klaviyoSent = {};
    function hasToken() {
      var t = form.querySelector('[name="h-captcha-response"],[name="g-recaptcha-response"],[name="cf-turnstile-response"]');
      return !!(t && t.value);
    }
    function captchaOnPage() {
      return !!(window.hcaptcha || window.grecaptcha || window.turnstile ||
        document.querySelector('script[src*="captcha"],iframe[src*="captcha"],[data-hcaptcha-widget-id]'));
    }
    function fail() {
      inflight = Math.max(0, inflight - 1);
      if (inflight === 0 && !sent) finish('error');
    }
    function send() {
      if (sent || !validated) return;
      inflight++;
      var data = new FormData(form);
      var email = String(data.get('contact[email]') || input.value || '').trim().toLowerCase();
      if (email && !klaviyoSent[email]) { klaviyoSent[email] = true; klaviyoSubscribe(email); }
      fetch(form.getAttribute('action') || form.action, { method: 'POST', body: data, credentials: 'same-origin' })
        .then(function (r) { return r.text().then(function (html) { return { url: r.url || '', html: html }; }); })
        .then(function (res) {
          if (/challenge/.test(res.url)) {
            if (!sent) { ssSet(PENDING_KEY, JSON.stringify({ email: email })); window.location.href = res.url; }
            return;
          }
          var doc = new DOMParser().parseFromString(res.html, 'text/html');
          var f = doc.querySelector('[data-mxnp-result]');
          var kind = f ? f.getAttribute('data-mxnp-result') : '';
          if (!kind && /customer_posted=true/.test(res.url)) kind = 'ok';
          if (kind !== 'ok' && kind !== 'exists') {
            var errs = doc.querySelectorAll('.form__message, .newsletter-form__message, [id$="-error"]');
            for (var i = 0; i < errs.length; i++) {
              if (/taken|already/i.test(errs[i].textContent)) { kind = 'exists'; break; }
            }
          }
          if (kind !== 'ok' && kind !== 'exists') { fail(); return; }
          sent = true; inflight = Math.max(0, inflight - 1);
          finish(kind, email);
        })
        .catch(fail);
    }
    /* Shopify's spam protection calls form.submit() once it has its token */
    form.submit = function () { send(); };

    form.addEventListener('submit', async function (e) {
      if (releasing) {
        releasing = false;
        if (e.defaultPrevented) return;
        if (captchaOnPage() && !hasToken()) return;
        e.preventDefault();
        send();
        return;
      }
      e.preventDefault();
      if (busy || sent) return;
      var email = input.value.trim().toLowerCase();
      if (!EMAIL.test(email)) { say(T.errEmail, true); return; }
      busy = true;
      root.classList.add('is-busy');
      say(T.sending, false);
      if (knownEmails().indexOf(email) > -1 || lsGet(DONE_KEY) === email) {
        await sleep(reduced ? 0 : 450);
        say('', false);
        finish('exists', email);
        return;
      }
      validated = email;
      await sleep(reduced ? 0 : 450);
      if (!window.fetch) { ssSet(PENDING_KEY, JSON.stringify({ email: email })); HTMLFormElement.prototype.submit.call(form); return; }
      releasing = true;
      var btn = form.querySelector('button[type="submit"]');
      if (form.requestSubmit) { try { form.requestSubmit(btn || undefined); } catch (err) { releasing = false; send(); } }
      else { releasing = false; send(); }
    });

    /* back from Shopify's spam check page */
    var pending = null;
    try { pending = JSON.parse(ssGet(PENDING_KEY)); } catch (e) {}
    if (pending) {
      ssDel(PENDING_KEY);
      if (flag) {
        if (history.replaceState) {
          var u = new URL(location.href); u.searchParams.delete('customer_posted'); u.hash = '';
          history.replaceState(null, '', u.pathname + u.search);
        }
        finish(flag, pending.email);
      }
    }
  }

  function boot() { document.querySelectorAll('[data-mxnp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var fresh = e.target.querySelector('[data-mxnp]');
    if (fresh) init(fresh);
  });
})();
